import { PEOPLE_RESOURCE_MANAGEMENT_API } from '@aibees/elephant/constants';
import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { PersonEnrichableRequest, PersonEnrichableResponse } from '../types';

export function usePersonEnrichableCountMutationApi() {
  const workspaceId = useWorkspace()?.id;

  return useBaseMutation<PersonEnrichableRequest, PersonEnrichableResponse>({
    url: PEOPLE_RESOURCE_MANAGEMENT_API.replace(
      ':wid',
      String(workspaceId)
    ).concat('?action=cost-estimation'),
    method: HttpMethod.post,
  });
}
